var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.groupClass},[(_vm.label)?[_c('h4',{staticClass:"content-group__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]:_vm._e(),_c('div',{staticClass:"content-group__body"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }